export default __webpack_public_path__ + "static/media/pickup_instore.84a061a0.svg";